import { jsxs as l, jsx as C } from "react/jsx-runtime";
import { getIconStyles as i } from "../styles.js";
const o = (e) => /* @__PURE__ */ l(
  "svg",
  {
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: i(e),
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_8892_10255)", children: [
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.13348 9.87663C-0.36741 11.3775 -0.367411 13.811 1.13348 15.3118L9.2863 23.4647C10.7872 24.9656 13.2206 24.9656 14.7215 23.4647L22.8743 15.3118C24.3752 13.811 24.3752 11.3775 22.8743 9.87663L14.7215 1.72381C13.2206 0.222921 10.7872 0.222921 9.2863 1.72381L1.13348 9.87663ZM12 18.5942C15.3137 18.5942 18 15.9079 18 12.5942C18 9.28053 15.3137 6.59424 12 6.59424C8.68629 6.59424 6 9.28053 6 12.5942C6 15.9079 8.68629 18.5942 12 18.5942Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M11.6118 10.5878C11.7507 10.5159 11.9066 10.4836 12.0626 10.4944C12.2186 10.5052 12.3686 10.5587 12.4963 10.6489C12.6239 10.7392 12.7243 10.8629 12.7865 11.0064C12.8486 11.1498 12.8701 11.3076 12.8486 11.4625C12.8271 11.6174 12.7635 11.7634 12.6646 11.8845C12.5658 12.0057 12.4355 12.0973 12.2881 12.1494C12.0386 12.2377 11.8225 12.4011 11.6698 12.6173C11.5171 12.8333 11.4351 13.0914 11.4352 13.356V13.681C11.4352 13.9951 11.6898 14.2497 12.0038 14.2497C12.3178 14.2497 12.5724 13.9951 12.5724 13.681V13.356C12.5724 13.3266 12.5815 13.2976 12.5985 13.2736C12.6154 13.2496 12.6394 13.2314 12.6672 13.2216C13.0111 13.1 13.3151 12.8862 13.5457 12.6035C13.7764 12.3208 13.9249 11.9802 13.975 11.6188C14.0252 11.2574 13.975 10.8892 13.83 10.5544C13.685 10.2196 13.4508 9.93115 13.1529 9.72048C12.8551 9.50982 12.505 9.38508 12.1411 9.35992C11.7771 9.33475 11.4132 9.41012 11.0892 9.57779C10.7652 9.74546 10.4935 9.99898 10.3038 10.3106C10.1141 10.6223 10.0137 10.9801 10.0137 11.3449C10.0136 11.659 10.2681 11.9136 10.5822 11.9136C10.8962 11.9137 11.1508 11.6592 11.1509 11.3451C11.1509 11.1888 11.1939 11.0354 11.2752 10.9019C11.3565 10.7683 11.4729 10.6597 11.6118 10.5878Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M12.5315 14.9042C12.3915 14.7642 12.2017 14.6856 12.0038 14.6856C11.8059 14.6856 11.616 14.7642 11.4761 14.9042C11.3361 15.0441 11.2575 15.234 11.2575 15.4319C11.2575 15.6298 11.3361 15.8196 11.4761 15.9596C11.616 16.0995 11.8059 16.1782 12.0038 16.1782C12.2017 16.1782 12.3915 16.0995 12.5315 15.9596C12.6715 15.8196 12.7501 15.6298 12.7501 15.4319C12.7501 15.234 12.6715 15.0441 12.5315 14.9042Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_8892_10255", children: /* @__PURE__ */ C(
        "rect",
        {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0 0.598145)"
        }
      ) }) })
    ]
  }
);
export {
  o as DiamondQuestionIcon
};
//# sourceMappingURL=DiamondQuestionIcon.js.map
